import { datadogLogs } from '@datadog/browser-logs';

export class Logger {
  static logRouteChange(newRoute: string) {
    datadogLogs.logger.info('route-change', { newRoute: newRoute });
  }

  static initializeLogger() {
    const config = datadogLogs.getInitConfiguration();

    if ((!config && process.env.REACT_APP_ENV === 'uat') || process.env.REACT_APP_ENV === 'staging' || process.env.REACT_APP_ENV === 'prod') {
      datadogLogs.init({
        clientToken: 'pubbec3d512a0179a4b6df114936813523b',
        forwardErrorsToLogs: true,
        sampleRate: 100,
        env: process.env.REACT_APP_ENV,
        service: `collaborate-${process.env.REACT_APP_ENV}`,
        silentMultipleInit: true,
        version: 'latest',
      });
    }
  }

  static setupLoggerContext(userId: string, email: string) {
    datadogLogs.addLoggerGlobalContext('id', userId);
    datadogLogs.addLoggerGlobalContext('email', email);
    datadogLogs.logger.info('Logger context initialized.');
  }
}
